<template>
  <div class="home medialinks-view-page-home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="order-page-main-sec agency-design-grid-right medialinks-page-main-sec"
    >
      <div class="desktop-respovsive-main-sec">
        <div class="media-links-content">
          <h2 class="text-heading">Media Placement</h2>
          <div class="text-1">
            Media placement offering allows you to select one or multiple media sites to publish your destination URL. Simply select the media sites you want us to target, share your destination URLs with us and let us do the magic to bring you the traffic you desire.          </div>
        </div>
        <div class="filter-section">
        <div class="order-input-field">
          <h3>Filters</h3>
          <div class="filter-row">
                <div class="form-group">
                    <label>
                      Media Site
                    </label>
                    <input
                      v-model.trim="websiteSearch"
                      type="text"
                      class="form-control"
                      placeholder="Search media site"
                    />
                </div>

                <div class="form-group">
                    <label>
                      Type of Website
                    </label>
                    <b-form-select
                      v-model="linkTypeSearch"
                      :options="LinkTypeOptions"
                      class="form-control"
                    />
                </div>

                <div v-if="showThirdFilterSearch" class="form-group">
                    <label>
                      {{ thirdFilterSearchLabel }}
                    </label>
                    <input
                      v-model="allSearch"
                      type="text"
                      class="form-control"
                      :placeholder="thirdFilterSearchPlaceholder"
                    />
                </div>
          </div>
        </div>
     
        <div class="filter-buttons">
          <button class="btn-order-links btn-1" @click="clearFilters">Clear all</button>
          <button class="btn-order-links btn-2" @click="applyFilters">Apply filters</button>
        </div>
      </div>
        <div class="editor-dashboard-sec-2 media-links-table-sec">
          <div class="table-responsive">
            <table class="addon-table">
              <thead>
                <tr>
                  <th>Media Site</th>
                  <!-- <th>DA</th>
                  <th>Traffic</th> -->
                  <th>Type of Website</th>
                  <th>Rel Attribute</th>
                  <th>Sponsored Tag</th>
                  <!-- <th>Turnaround Time</th> -->
                  <th>Price</th>
                  <th class="select-column">Select</th>
                  <th class="view-details-column"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(media, index) in mediaRows"
                  :key="`${media.id}-${index}`"
                  :class="{ 'is-selected-row': media.selected }"
                >
                  <td>
                    <a
                      :href="getMediaSiteUrl(media.site)"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="media-site-link"
                      v-b-tooltip.hover.top="media.site"
                    >
                      <span class="media-site-text">{{ media.site }}</span>
                      <i class="fas fa-external-link-alt"></i>
                    </a>
                  </td>
                  <!-- <td>
                    <span class="pill-badge">{{ media.da }}</span>
                  </td>
                  <td>
                    <span class="pill-badge">{{ commaSeperatedValue(media.traffic, '--') }}</span>
                  </td> -->
                  <td>
                    {{ media.type_of_website }}
                  </td>
                  <td>{{ media.rel_attribute }}</td>
                  <td>{{ media.sponsored_tag }}</td>
                  <!-- <td>{{ media.turnaround_time }}</td> -->
                  <td>${{ numberFormat(media.price, "") }}</td>
                  <td class="select-column">
                    <div class="btn-box">
                      <button
                        type="button"
                        class="table-action-btn"
                        :class="{ 'is-selected': media.selected }"
                        @click="toggleMediaSelection(media.id)"
                      >
                        <i :class="media.selected ? 'fas fa-check' : 'fas fa-plus'"></i>
                      </button>
                    </div>
                  </td>
                  <td class="view-details-column">
                    <button
                      type="button"
                      class="media-details-link"
                      @click="openMediaDetails(media)"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
                <tr v-if="!mediaRows.length">
                  <td colspan="7" class="text-center">No media placements found.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="pagination-list">
        <paginate
          :click-handler="fetchMediaPlacements"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="filter.length"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>

      <b-modal
        id="media-placement-details-modal"
        v-model="detailsModalShow"
        centered
        scrollable
        modal-class="media-placement-details-modal-root"
        content-class="media-placement-details-modal-content"
        body-class="media-placement-details-modal-body"
        footer-class="media-placement-details-modal-footer"
        header-class="media-placement-details-modal-header"
        @hidden="onDetailsModalHidden"
      >
        <template #title>
          <a
            v-if="detailMedia"
            :href="getMediaSiteUrl(detailMedia.site)"
            target="_blank"
            rel="noopener noreferrer"
            class="media-details-modal-title-link"
          >
            <span class="media-details-modal-title-text">{{ detailMedia.site }}</span>
            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
          </a>
          <span v-else class="media-details-modal-title">Details</span>
        </template>
        <template v-if="detailMedia">
          <p class="media-details-section-label">Details:</p>
          <div class="media-details-panel">
            <dl class="media-details-dl">
              <div class="media-details-row">
                <dt>Industry</dt>
                <dd>{{ detailMedia.industry }}</dd>
              </div>
              <div class="media-details-row">
                <dt>Location</dt>
                <dd>{{ detailMedia.location_label }}</dd>
              </div>
              <div class="media-details-row">
                <dt>Authority</dt>
                <dd>{{ detailMedia.da }}</dd>
              </div>
              <div class="media-details-row">
                <dt>Traffic</dt>
                <dd>{{ commaSeperatedValue(detailMedia.traffic, '--') }}</dd>
              </div>
              <div class="media-details-row">
                <dt>Sample Post</dt>
                <dd>
                  <a
                    v-if="detailMedia.sample_post_href"
                    :href="detailMedia.sample_post_href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="media-details-sample-link"
                  >
                    {{ truncateMiddle(detailMedia.sample_post_display, 42) }}
                  </a>
                  <span v-else>{{ detailMedia.sample_post_display }}</span>
                </dd>
              </div>
              <div class="media-details-row">
                <dt>Turnaround Time</dt>
                <dd>{{ detailMedia.turnaround_time }}</dd>
              </div>
            </dl>
          </div>
        </template>
        <template #footer>
          <div class="media-placement-details-footer-inner">
            <button
              type="button"
              class="btn-order-links btn-2 media-details-select-btn"
              :disabled="!detailMedia"
              @click="selectFromDetailsModal"
            >
              Select
            </button>
          </div>
        </template>
      </b-modal>
    </section>
    <div class="new-product-page-btn-box medialinks-view-page-btn-box">
                 <!-- Action Buttons Section -->


              <!-- Order Summary Section -->
                <div class="order-summary-section">
                    <div class="summary-left">
                        <div class="total-links-text">Total Media {{ selectedMediaRows.length <= 1 ? "Link" : "Links" }}:
                          <span class="total-links-value">{{ selectedMediaRows.length }}</span>
                        </div>
                    </div>
                    <div class="summary-right">
                        <div class="total-amount">
                            <span class="total-label">Total</span>
                            <span class="total-value">USD ${{ selectedMediaTotalDisplay }}</span>
                        </div>
                        <button class="btn-proceed-payment" type="button" :disabled="!selectedMediaRows.length" @click="goToMediaLinksSummary">
                          Next
                        </button>
                    </div>
                </div>
              </div>
  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import Paginate from "vuejs-paginate-next";
import { numberFormat, commaSeperatedValue } from "@/prod.js";
import swal from "sweetalert2";
export default {
  components: {
    HeaderView,
    LoaderComponent,
    Paginate,
  },

  async mounted() {
    await Promise.all([this.LinkTypeOptionsList(), this.fetchMediaPlacements()]);
  },
  watch: {
    linkTypeSearch() {
      this.allSearch = "";
      this.appliedSearch = "";
      this.appliedSearchType = null;
    },
  },
  data() {
    return {
      numberFormat,
      commaSeperatedValue,
      loading: false,
      websiteSearch: "",
      allSearch: "",
      /** Search text last applied via "Apply filters" (typing does not filter until Apply). */
      appliedSearch: "",
      /** Last applied search dimension for API + client filter: industry | location */
      appliedSearchType: null,
      linkTypeSearch: null,
      LinkTypeOptions: [{ text: "Select Type", value: null }],
      mediaRows: [],
      selectedMediaById: {},
      filter: {
        page: 1,
        per_page: 100,
        last_page: 1,
        length: 0,
      },
      totalRecords: 0,
      rows: [],
      paginationData: {},
      detailsModalShow: false,
      detailMedia: null,
    };
  },
  methods: {
    async LinkTypeOptionsList() {
      try {
        const res = await this.$store.dispatch("Link/getLinkTypeOptionsDataAction");
        const list = Array.isArray(res) ? res : [];
        this.LinkTypeOptions = [
          { text: "Select Type", value: null },
          ...list.map((item) => ({ text: item.name, value: item.id })),
        ];
      } catch (e) {
        this.LinkTypeOptions = [{ text: "Select Type", value: null }];
      }
    },
    /** Label text for selected link type option (Type of Website dropdown). */
    getLinkTypeOptionText(linkTypeId) {
      if (linkTypeId == null || linkTypeId === "") return "";
      const opt = this.LinkTypeOptions.find((o) => o.value === linkTypeId);
      return opt && opt.text ? String(opt.text).trim() : "";
    },
    /**
     * Map API link type name to search mode for the 3rd filter + `searchtype` query param.
     * Industry Specific → industry; Local → location; Media → no search field.
     */
    inferSearchModeFromLinkType(linkTypeId) {
      const name = this.getLinkTypeOptionText(linkTypeId).toLowerCase();
      if (!name || name === "select type") return null;
      if (name.includes("industry specific")) return "industry";
      const isMedia =
        /^media$/i.test(name.trim()) ||
        /^media[\s-–—]/i.test(name.trim());
      if (isMedia) return null;
      if (/\blocal\b/.test(name)) return "location";
      return null;
    },
    toAmount(value) {
      const normalized = String(value ?? "")
        .replace(/,/g, "")
        .replace(/[^\d.-]/g, "")
        .trim();
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    resolveMediaPrice(row) {
      const candidates = [
        row?.client_fee,
        row?.price,
        row?.total_price,
        row?.link_price,
        row?.cost,
        row?.clientFee,
      ];
      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === "") continue;
        const amount = this.toAmount(candidate);
        if (Number.isFinite(amount)) return amount;
      }
      return 0;
    },
    parseDaValue(value) {
      if (value == null) return null;
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
      }
      const normalized = String(value).replace(/,/g, "").trim();
      const direct = Number(normalized);
      if (Number.isFinite(direct)) return direct;
      const match = normalized.match(/-?\d+(\.\d+)?/);
      if (!match) return null;
      const parsed = Number(match[0]);
      return Number.isFinite(parsed) ? parsed : null;
    },
    getWebsiteTypeList(row) {
      const source = row?.website_type ?? row?.link_type ?? null;
      if (Array.isArray(source)) {
        return source
          .filter((item) => item && (item.id != null || item.name))
          .map((item) => ({ id: item.id ?? null, name: item.name || "--" }));
      }
      if (source && typeof source === "object") {
        return [{ id: source.id ?? null, name: source.name || "--" }];
      }
      return [];
    },
    normalizeDisplayValue(value) {
      if (value === null || value === undefined || value === "") return "--";
      if (typeof value === "boolean") return value ? "Yes" : "No";
      return String(value);
    },
    truncateMiddle(str, maxLen) {
      if (str == null || str === "" || str === "--") return str;
      const s = String(str);
      if (s.length <= maxLen) return s;
      const inner = maxLen - 3;
      const left = Math.ceil(inner / 2);
      const right = Math.floor(inner / 2);
      return `${s.slice(0, left)}...${s.slice(s.length - right)}`;
    },
    formatLocationLabel(location) {
      if (location == null || location === "") return "--";
      if (typeof location === "string") {
        const s = location.trim();
        return s || "--";
      }
      if (typeof location === "object") {
        if (Array.isArray(location)) {
          const parts = location
            .map((item) =>
              typeof item === "string" ? item.trim() : this.formatLocationLabel(item)
            )
            .filter((p) => p && p !== "--");
          return parts.length ? parts.join(", ") : "--";
        }
        const label =
          location.name ||
          location.label ||
          location.state ||
          location.region ||
          location.title ||
          location.city;
        if (label) return String(label);
      }
      return "--";
    },
    resolveSamplePostFields(row) {
      const raw =
        row?.sample_post ??
        row?.sample_url ??
        row?.example_url ??
        row?.post_url ??
        row?.sample_link ??
        row?.example_post ??
        "";
      const trimmed = String(raw).trim();
      if (!trimmed) {
        return { display: "--", href: null };
      }
      const href = /^https?:\/\//i.test(trimmed)
        ? trimmed
        : /^\/\//.test(trimmed)
          ? `https:${trimmed}`
          : `https://${trimmed.replace(/^\/+/, "")}`;
      return { display: trimmed, href };
    },
    openMediaDetails(media) {
      this.detailMedia = media;
      this.detailsModalShow = true;
    },
    onDetailsModalHidden() {
      this.detailMedia = null;
    },
    selectFromDetailsModal() {
      if (!this.detailMedia) return;
      const row = this.mediaRows.find(
        (m) => String(m?.id) === String(this.detailMedia.id)
      );
      if (row) {
        row.selected = true;
        this.selectedMediaById[String(row.id)] = { ...row, selected: true };
      }
      this.detailsModalShow = false;
    },
    mapMediaPlacementRow(row) {
      const websiteTypes = this.getWebsiteTypeList(row);
      const resolvedPrice = this.resolveMediaPrice(row);
      const authorityRaw =
        row?.authority ??
        row?.da ??
        row?.domain_authority ??
        row?.exact_da_dr ??
        row?.exact_da ??
        null;
      const authorityNumber = this.parseDaValue(authorityRaw);
      const sampleFields = this.resolveSamplePostFields(row);
      const locationLabel = this.formatLocationLabel(row?.location);
      const samplePostValue =
        sampleFields.href ||
        (sampleFields.display && sampleFields.display !== "--" ? sampleFields.display : "");
      const turnaroundValue = this.normalizeDisplayValue(
        row?.turnaround_time ?? row?.turn_around_time ?? row?.tat
      );
      return {
        id: row?.id,
        product_id: row?.product_id ?? row?.product?.id ?? null,
        site: row?.website || "--",
        da: authorityRaw ?? "--",
        da_numeric: authorityNumber,
        niche: row?.category?.name || "--",
        industry: this.normalizeDisplayValue(
          row?.industry ??
            row?.industry_name ??
            row?.niche ??
            row?.category?.name
        ),
        traffic: row?.traffic ?? "--",
        location: locationLabel === "--" ? "" : locationLabel,
        location_label: locationLabel,
        sample_post: samplePostValue,
        sample_post_display: sampleFields.display,
        sample_post_href: sampleFields.href,
        type_of_website: this.normalizeDisplayValue(
          row?.type_of_website ??
            row?.typeOfWebsite ??
            (websiteTypes[0]?.name && websiteTypes[0].name !== "--"
              ? websiteTypes[0].name
              : null)
        ),
        countries: row?.location ? [row.location] : [],
        website_type_tags: websiteTypes.length ? websiteTypes : [{ id: null, name: "--" }],
        website_type: websiteTypes[0]?.name || "--",
        website_type_id: websiteTypes[0]?.id ?? null,
        category_id: row?.category?.id ?? null,
        rel_attribute: this.normalizeDisplayValue(
          row?.rel_attribute ?? row?.relAttributes ?? row?.rel
        ),
        sponsored_tag: this.normalizeDisplayValue(
          row?.sponsored_tag ?? row?.sponsoredTag ?? row?.sponsored
        ),
        turnaround_time: turnaroundValue,
        client_fee: resolvedPrice,
        price: resolvedPrice.toFixed(2),
        selected: false,
      };
    },

    async fetchMediaPlacements() {
      this.loading = true;
      try {
        const payload = {
          website: this.websiteSearch || undefined,
          link_type: this.linkTypeSearch || undefined,
          generalSearch: this.appliedSearch || undefined,
          searchtype: this.appliedSearchType || undefined,
          page: this.filter.page,
          per_page: this.filter.per_page,
          sort_by: "website",
          sort_order: "asc",
        };
        const res = await this.$store.dispatch("Link/getMediaPlacementsDataAction", payload);
        const dataRows = Array.isArray(res?.data) ? res.data : [];
        this.mediaRows = dataRows.map((row) => {
          const mapped = this.mapMediaPlacementRow(row);
          const id = String(mapped.id);
          mapped.selected = !!this.selectedMediaById[id];
          return mapped;
        });
        this.paginationData = res;
        this.rows = dataRows;
        this.totalRecords = res?.meta?.total ?? dataRows.length;
        this.filter.page = res?.meta?.current_page ?? this.filter.page;
        this.filter.per_page = res?.meta?.per_page ?? this.filter.per_page;
        this.filter.last_page = res?.meta?.last_page ?? 1;
        this.filter.length = res?.meta?.total ?? dataRows.length;
      } catch (error) {
        this.mediaRows = [];
        this.rows = [];
        this.totalRecords = 0;
        this.filter.last_page = 1;
        this.filter.length = 0;
      } finally {
        this.loading = false;
      }
    },
    changePagination() {
      this.filter.page = 1;
      this.fetchMediaPlacements();
    },
    applyFilters() {
      this.appliedSearch = (this.allSearch || "").trim();
      this.appliedSearchType = this.inferSearchModeFromLinkType(this.linkTypeSearch);
      this.filter.page = 1;
      this.fetchMediaPlacements();
    },
    clearFilters() {
      this.websiteSearch = "";
      this.allSearch = "";
      this.appliedSearch = "";
      this.appliedSearchType = null;
      this.linkTypeSearch = null;
      this.filter.page = 1;
      this.fetchMediaPlacements();
    },
    getMediaSiteUrl(site) {
      if (!site) return "#";
      return /^https?:\/\//i.test(site) ? site : `https://${site}`;
    },
    toggleMediaSelection(mediaId) {
      const row = this.mediaRows.find((media) => String(media?.id) === String(mediaId));
      if (!row) return;
      row.selected = !row.selected;
      const id = String(mediaId);
      if (row.selected) {
        this.selectedMediaById[id] = { ...row, selected: true };
      } else {
        delete this.selectedMediaById[id];
      }
    },
    goToMediaLinksSummary(){
      const selectedRows = Object.values(this.selectedMediaById);
      if (!selectedRows.length) {
        swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select at least one media link!",
        });
        return;
      }
      localStorage.setItem("media-placements-selected", JSON.stringify(selectedRows));
      sessionStorage.removeItem("payment-flow-type");
      this.$router.push({
        name: "media-links-summary",
        query: this.$route.query || {},
      });
    }
  },

  computed: {
    /** Industry Specific / Local — show 3rd search; Media and others hide it. */
    showThirdFilterSearch() {
      return this.inferSearchModeFromLinkType(this.linkTypeSearch) != null;
    },
    /** Live label for 3rd filter (follows current Type of Website selection). */
    thirdFilterSearchLabel() {
      const mode = this.inferSearchModeFromLinkType(this.linkTypeSearch);
      if (mode === "industry") return "Search Industry";
      if (mode === "location") return "Search Location";
      return "Search";
    },
    thirdFilterSearchPlaceholder() {
      const mode = this.inferSearchModeFromLinkType(this.linkTypeSearch);
      if (mode === "industry") return "e.g. Health";
      if (mode === "location") return "e.g. United States";
      return "Search";
    },
    selectedMediaRows() {
      return Object.values(this.selectedMediaById);
    },
    selectedMediaTotal() {
      return this.selectedMediaRows.reduce(
        (acc, media) => acc + (Number(media?.price) || 0),
        0
      );
    },
    selectedMediaTotalDisplay() {
      return this.numberFormat(this.selectedMediaTotal || 0) || "0.00";
    },
  },
};
</script>
 